export default {
  client: null,
  user: (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))) || null,
  accessToken: localStorage.getItem("access_token") || null,
  tokenExpires: (localStorage.getItem("access_token_expires") && new Date(localStorage.getItem("access_token_expires"))) || null,
};